import {dataTestId} from '@hconnect/uikit'
import {mergeSx} from '@hconnect/uikit/src/lib2'
import {Box, BoxProps} from '@mui/material'
import React from 'react'

interface LegendProps extends Pick<BoxProps, 'sx'> {
  testId?: string
  children: React.ReactNode
}

/**
 * Simple wrapper around the MUI Box component that lays out the legend items
 */
export const Legend = React.memo(({children, sx: customSx, testId = 'legend'}: LegendProps) => {
  return (
    <Box
      {...dataTestId(testId)}
      sx={mergeSx(
        {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: 2
        },
        customSx
      )}
    >
      {children}
    </Box>
  )
})
Legend.displayName = 'Legend'
